module.exports = __webpack_public_path__ + "media/images/common/callout-yellow-5c4d2d0e22ec789bf381c90d4f0b7c30.svg";